import $ from 'jquery';

/**
 * CarouselView
 *
 * @class CarouselView
 * @constructor
 */
export default class CarouselView {
    constructor($carousel) {
        /**
         * A reference to the carousel container
         *
         * @property carousel
         * @type {type}
         * @public
         */
        if ($carousel instanceof $) {
            this.$carousel = $carousel;
        } else {
            throw('$carousel is not a jquery object!');
        }

        /**
        * Slide count
        *
        * @property totalSlides
        * @type int
        * @default false
        * @public
        */
        this.totalSlides = null;

        /**
        * Is Enabled?
        *
        * @property isEnabled
        * @type boolean
        * @default false
        * @public
        */
        this.isEnabled = false;

        this.init();
    }

    /**
     * Initializes methods
     *
     * @method init
     * @public
     * @chainable
     */
    init() {

        this.setupHandlers()
            .createChildren()
            .enable();
    }

    /**
     * SetupHandlers
     *
     * @method setupHandlers
     * @public
     * @chainable
     */
    setupHandlers() {
        this.handleOnBulletClick = this.onBulletClick.bind(this);
        this.handlOnButtonClick = this.onButtonClick.bind(this);

        return this;
    }

    /**
     * createChildren
     *
     * @method createChildren
     * @public
     * @chainable
     */
    createChildren() {
        this.$slides = this.$carousel.find('[data-carousel-slide]');
        this.$bullets = this.$carousel.find('[data-carousel-bullet]');
        this.$buttons = this.$carousel.find('[data-carousel-button]');

        this.totalSlides = this.$slides.length;

        return this;
    }

    /**
    * Method goToSlide (indexed starting at 1)
    *
    * @method goToSlide
    * @chainable
    * @public
    */
    goToSlide(index) {

        index -= 1; //jquery is 0-indexed

        this.$slides.filter('.active').toggleClass('active');
        this.$slides.eq(index).toggleClass('active');

        this.$bullets.filter('.active').toggleClass('active');
        this.$bullets.eq(index).toggleClass('active');  

        return this;
    }

    /**
    * Method go to next slide (direction +/- from current)
    * making sure to loop if at beginning or end of collection
    *
    * @method advanceSlide
    * @chainable
    * @public
    */
    advanceSlide(direction) {
        let $activeElement = this.$slides.filter('.active')
        let currentIndex = this.$slides.index($activeElement) + 1;
        let nextIndex = currentIndex + direction;

        if (nextIndex > this.totalSlides) {
            this.goToSlide(1);
        } else if (nextIndex < 1) {
            this.goToSlide(this.totalSlides);
        } else {
            this.goToSlide(nextIndex);
        }
        
        return this;
    }

    /**
    * Method onBulletClick
    *   
    * @method onBulletClick
    * @chainable
    * @public
    */
    onBulletClick(e) {
        let $clickTargetIndex = $(e.target).closest('[data-carousel-bullet]').data('carouselBullet');
        this.goToSlide($clickTargetIndex);
    }

    /**
    * Method onNextPreviousClick
    *
    * @method onNextPreviousClick
    * @chainable
    * @public
    */
    onButtonClick(e) {
        let direction = $(e.target).closest('[data-carousel-button]').data('carousel-button');
        this.advanceSlide(direction);
    }

    /**
     * Enable
     *
     * @method enable
     * @public
     * @chainable
     */
    enable() {

        if(this.isEnabled) {
            return this;
        }

        this.$bullets.on('click', this.handleOnBulletClick);
        this.$buttons.on('click', this.handlOnButtonClick);

        this.isEnabled = true;

        return this;
    }

    /**
     * Disable
     *
     * @method disable
     * @public
     * @chainable
     */
    disable() {
        if(!this.isEnabled) {
            return this;
        }

        this.isEnabled = false;

        return this;
    }
}